/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".be-modal confirm-modal{display:block;max-width:500px}.be-modal confirm-modal>.modal-header{margin-bottom:10px}.be-modal confirm-modal>.mat-dialog-contents>.bold{font-weight:500}.be-modal confirm-modal>.mat-dialog-contents>p{font-size:1.5rem}"];
export { styles as styles };
